<template>
  <div class="main-home" style="padding-bottom: 0px;">
    <div v-if="userType !== 2">
      <h2>欢迎，{{userName}}</h2>
    </div>
    <template v-else>
      <product-list/>
    </template>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ProductList from "@/views/main/components/ProductList.vue";
  export default {
    name: "Home",
    components: { ProductList },
    data() {
      return {
        userType: loginUtil.getUserType(),
        userName: loginUtil.getUserName(),
      };
    },
    mounted() {
      this.checkLogin();
    },
    methods: {
      checkLogin() {
        this.$http.get("basic", "account/checkLogin");
      },
    },
  };
</script>

<style lang="scss" scoped>
.main-home{
  padding-bottom: 0px;
}
</style>
